import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes.ts'

import { UmraTag } from 'pages/umrah/main-page/components/umrah-card-list/components'

import { prepareImages } from 'entities/umrah/libs'
import umraListStore from 'entities/umrah/models/umrah-list.ts'
import { UmrahTourInfo } from 'entities/umrah/ui/umrah-tour-info'

import { UmrahTour } from 'shared/api/umrah/tours'
import GhostImage from 'shared/images/ghost.png'
import { Carousel } from 'shared/ui/carousel'

import s from './styles.module.scss'

interface Props {
  tour?: UmrahTour
}

export const UmrahCard = ({ tour }: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleCardClick = (tourId?: string, scheduleId?: string) => {
    if (!tourId || !scheduleId) return

    umraListStore.setUmrahTour(tour)
    navigate(RoutingPaths.umrah.tourDetail.path(tourId, scheduleId))
  }

  const preparedImages = useMemo(() => prepareImages(tour), [tour])

  return (
    <div
      className={s.container}
      onClick={() => handleCardClick(tour?.id, tour?.schedule?.id)}
    >
      <div className={s.gallery}>
        <Carousel
          size={'small'}
          dotsVariant="custom"
          images={preparedImages}
          errorImage={GhostImage}
          showCounter
        />

        <div className={s.tag}>
          <UmraTag
            title={t('umrah_block.from_city', { city: tour?.departure_from })}
          />
        </div>
      </div>

      <UmrahTourInfo tour={tour} />
    </div>
  )
}
